export default function Groups() {
  return <div className="p-6 text-2xl">Groups Screen</div>;
}